import { useEffect } from 'react';

/**
 * Light content protection for the PUBLIC site: deters casual copying of text
 * and saving of images by disabling the right-click menu, copy, and image drag.
 * Form fields (input/textarea/contenteditable) are exempt so the Contact and
 * Careers forms keep working normally.
 *
 * Note: this is a deterrent, not real security — anyone can still read source
 * or disable JS. Real protection comes from HTTPS + server-side controls.
 */
const isFormField = (el) =>
  !!el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);

export const ContentProtection = () => {
  useEffect(() => {
    const onContextMenu = (e) => {
      if (!isFormField(e.target)) e.preventDefault();
    };
    const onCopy = (e) => {
      if (!isFormField(e.target)) e.preventDefault();
    };
    const onDragStart = (e) => {
      if (e.target && e.target.tagName === 'IMG') e.preventDefault();
    };
    document.addEventListener('contextmenu', onContextMenu);
    document.addEventListener('copy', onCopy);
    document.addEventListener('dragstart', onDragStart);
    return () => {
      document.removeEventListener('contextmenu', onContextMenu);
      document.removeEventListener('copy', onCopy);
      document.removeEventListener('dragstart', onDragStart);
    };
  }, []);

  return null;
};

export default ContentProtection;
